import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { captureUtm, track } from "@/lib/store";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { AiAssistant } from "@/components/AiAssistant";
import Home from "@/pages/Home";
import Repairs from "@/pages/Repairs";
import Contatti from "@/pages/Contatti";
import Login from "@/pages/Login";
import OrderStatus from "@/pages/OrderStatus";
import Checkout from "@/pages/Checkout";
import ControlCenter from "@/pages/admin/ControlCenter";
import ValutaIphone from "@/pages/ValutaIphone";
import Usato from "@/pages/Usato";
import UsatoDettaglio from "@/pages/UsatoDettaglio";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (!pathname.startsWith("/admin") && pathname !== "/login") {
      captureUtm();
      track("page_view");
    }
  }, [pathname]);
  return null;
};

const StoreLayout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
    <WhatsAppFloat />
    <AiAssistant />
  </>
);

function App() {
  return (
    <div className="App min-h-screen bg-white text-neutral-900">
      <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<StoreLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/catalogo" element={<Navigate to="/" replace />} />
              <Route path="/prodotto/:slug" element={<Navigate to="/" replace />} />
              <Route path="/riparazioni" element={<Repairs />} />
              <Route path="/usato" element={<Usato />} />
              <Route path="/usato/:id" element={<UsatoDettaglio />} />
              <Route path="/valuta-iphone" element={<ValutaIphone />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/stato-ordine" element={<OrderStatus />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><ControlCenter /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      </HelmetProvider>
      <Toaster theme="light" position="top-center" richColors />
    </div>
  );
}

export default App;
